export const ANALYTICS_SOURCE = 'life-web-footer';
